import {AssignTagForm} from "../common/models";
import {postRequest} from "./postRequest";

export const assignTagToEntity = (assignTagForm: AssignTagForm) => {
    return postRequest('/api/tags/assignTag', assignTagForm)
}